import React from 'react'
import { useContext } from 'react';
import { GlobalState } from '../../GlobalState';
import { useEffect } from 'react';
import { api } from '../../util/urlConfig';
import moment from 'moment';
import './supplierFeedbackNotifyComponent.css'
import { useState } from 'react';
import axios from '../../helpers/axios';

export default function DamageNotifyComponent({ id }) {
    const [damageDetail, setDamageDetail] = useState(null);

    const getDamageDetail = async (damId) => {
        const res = await axios.get(`/damage/${damId}`);
        setDamageDetail(res.data.response.data);
    }

    useEffect(() => {
        getDamageDetail(id);
    }, [id])

    return (
        <>
            {
                damageDetail ?
                    <div className='notify-main-container'>
                        <div className='notify-content-area'>
                            <img className='notify-img' src={damageDetail.customer && damageDetail.customer.upload_image ? api + "/" + damageDetail.customer.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
                            <div className='notify-content-detail'>
                                <div className='notify-name'>
                                    {
                                        damageDetail.customer ? damageDetail.customer.first_name + " " + damageDetail.customer.last_name : ""
                                    }
                                </div>


                                <div className='notify-subname'>You have returned {damageDetail.quantity} of damage products.</div>
                                <div className='notify-subname'>
                                    <i className='uil uil-clock'></i>
                                    <span>{moment(damageDetail.created_at).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
    return (
        <div>DamageNotifyComponent</div>
    )
}
